import { render } from "./EditCreance.vue?vue&type=template&id=0cd9dd08&scoped=true&ts=true"
import script from "./EditCreance.vue?vue&type=script&lang=ts"
export * from "./EditCreance.vue?vue&type=script&lang=ts"

import "./EditCreance.vue?vue&type=style&index=0&id=0cd9dd08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd9dd08"]])

export default __exports__